import Dashboard from "../../../container/dashboard/index";
import Mapview from "../../../container/dashboard/Mapview";
import LogisticsManagement from "../../../container/dashboard/logisticManagement";

const dashboardRoute = [
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "dashboard/:id",
    element: <Mapview />,
  },
  {
    path: "dashboard/logistics-management",
    element: <LogisticsManagement />,
  },
  {
    path: "dashboard/logistics-management/:tab", 
    element: <LogisticsManagement />,
  },
  {
    path: "dashboard/logistics-management/:tab/:id",
    element: <LogisticsManagement />,
  }
];

export default dashboardRoute;
